import { render, staticRenderFns } from "./m-search-user.vue?vue&type=template&id=1390b3d5&"
import script from "./m-search-user.vue?vue&type=script&setup=true&lang=js&"
export * from "./m-search-user.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports